import { IServerProps } from 'mod/product-list/interface';
import ListPage from '@app/list/ListPage';

const Page: Globals.NextPage<IServerProps> = props => {
    return <ListPage {...props}/>;
}

Page.pageConf = {
    pageCode: 'list',
    bodyClassName: 'bg-white',
};

export { getServerSideProps } from 'mod/product-list/service';

export default Page;
